import React, { useEffect, useRef, useState } from 'react'
import { NavBarUserScreen } from '../navBar/NavBarUserScreen'
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import { ApiStorage, ApiUrl } from '../../services/ApiRest';
import { Link } from 'react-router-dom';
import '../initialsPages/carouselTiger/CarouselStyles.css';

export const SubscriberHomeScreen = () => {
  const scrollRef = useRef(null);

  const toastId = React.useRef(null);
  const [ci, setci] = useState('')
  const [userData, setuserData] = useState([])
  const [montlyTours, setmontlyTours] = useState([])
  const [commingTour, setcommingTour] = useState([])
  const [answer, setanswer] = useState('')
  const [bennefitsDate, setbennefitsDate] = useState([])



  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount = container.offsetWidth * 0.1;
    container.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  };

  const loadUser = async () => {
    var token = localStorage.getItem('access_token')
    axios.get(ApiUrl + "passenger/profile", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
        var user = response.data.user;
        setuserData(user)
        setci(user.ci);
        searchClient(user.ci);

      })
      .catch(() => {
        localStorage.removeItem('access_token');
        window.location.href = "/login";
      });
  }

  const loadMonthlyTours = async () => {
    axios.get(ApiUrl + "monthly-tour-available")
      .then(response => {
        const data = response.data;
        setmontlyTours(data);
        // console.log(response)
      })
      .catch(() => {

      });
  }

  const searchClient = async (cidocument) => {
    // alert(cidocument);
    await axios.get(ApiUrl + "consult-apply-benefit/" + cidocument)
      .then(response => {
        const data = response.data;
        console.log("******comming")
        console.log(data)

        setanswer(data.message)
        setbennefitsDate(data.data)

        if (data.message === 'No aplica' || data.message === 'No aplica fecha pasada') {
          setcommingTour(null)
        } else {
          setcommingTour(data.tour[0])
        }

      })
      .catch(e => {
        console.log(e)
      })

  }

  useEffect(() => {
    loadUser();
    loadMonthlyTours();

  }, [])


  return (
    <>
      <div className="container py-4 ">
        {/* Encabezado de bienvenida */}
        <div className="mb-4 camping-letters" >
          <h1>¡Hola, {userData.name}!</h1>
          <h5 className="text-muted">¿Listo para tu próxima aventura?</h5>
          <p>Explora rutas increíbles, accede a tus reservas y revisa tus beneficios.</p>
        </div>

        {/* Tours destacados */}
        <div className="mb-4 ">
          <h3 className="text-muted camping-letters">Tours Disponibles 🗻🏕️</h3>
          <div className="row">
            {/* {montlyTours.map((tour, index) => (
              <div className="col-md-4 col-sm-6 mb-3 " key={index}>
                <div className="card h-100">
                  <div className="card-img-top bg-secondary" style={{ height: '150px' }}></div>
                  <div className="card-body">
                    <p className="card-title">{tour.tour_destiny}</p>
                    <p className="card-text">{tour.departure_date}</p>
                    <button className="btn btn-outline-primary">Ver detalles</button>
                  </div>
                </div>
              </div>
            ))} */}
            <div className="carousel-container">
              <button className="scroll-button left" onClick={() => scroll('left')}>
                {/* <i className="fa-solid fa-chevron-left"></i> */}
                <i className="far fa-arrow-alt-circle-left"></i>
              </button>

              <div className="carouselTour" ref={scrollRef}>

                {montlyTours.map((tour, index) => (
                  <div className="carousel-card" key={index}>
                    <Link to={`/partner/${tour.partner_id}`} className="carousel-link">
                      {/* <img src={partner.img_logo} alt={partner.name} /> */}
                      {/* <img src={`${ApiStorage + tour.img_1}`} style={{ width: '100%' }} className="card-img-top carousel-card2" alt="..."></img> */}
                      <img
                        src={`${ApiStorage + tour.img_1}`}
                        className="card-img-top custom-img-large"
                        alt="..."
                      />
                      <div className="carousel-info">
                        <p><i className="fas fa-mountain"></i>{' : ' + tour.tour_destiny}</p>
                        <p><i className="fas fa-map-marker-alt"></i>{' : ' + tour.city}</p>
                        <p><i className="fas fa-calendar"></i> {': ' + tour.departure_date}</p>
                        <button className="btn btn-sm btn-outline-success" style={{ textAlign: "right !important" }}>Ver detalles</button>

                      </div>
                    </Link>
                  </div>
                ))}
              </div>
              <button className="scroll-button right" onClick={() => scroll('right')}>
                <i className="far fa-arrow-alt-circle-right"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Buscar tours */}
        {/* <div className="mb-4">
          <h3>Buscar tours</h3>
          <div className="row g-2">
            <div className="col-md-4">
              <input className="form-control" placeholder="Destino" />
            </div>
            <div className="col-md-4">
              <input type="date" className="form-control" />
            </div>
            <div className="col-md-4">
              <select className="form-select">
                <option>Tipo de tour</option>
                <option>Camping</option>
                <option>Montaña</option>
                <option>Glamping</option>
              </select>
            </div>
          </div>
        </div> */}

        {/* Mis próximos tours */}
        <div className="mb-4">
          <h3 className="text-muted camping-letters">Mis próximos tours</h3>

          {
            (commingTour != null) ?
              <div className="mt-2 p-2 bg-light rounded shadow-sm">
                <div className="d-flex align-items-center">
                  <div className="bg-secondary" style={{ width: '150px', height: 'auto' }}>
                    <img
                      src={`${ApiStorage + commingTour.img_1}`}
                      className="card-img-top "
                      alt="..."
                    />
                  </div>
                  <div className="ms-3">
                    <h5>{commingTour.departure_date}</h5>
                    <p>{commingTour.tour_destiny}</p>
                    <button className="btn btn-outline-secondary">Ver detalles</button>
                  </div>
                </div>
              </div>
              :

              <div className="mt-4 p-4 bg-light rounded shadow-sm">
                <h4 className="fw-bold text-dark mb-2">🌄 ¡Aún no tienes aventuras programadas!</h4>
                <p className="text-muted mb-1">
                  Pero la montaña te espera... Únete a nuestras próximas rutas y <strong>vive experiencias únicas</strong> con Camping Chimborazo.
                </p>
                <p className="text-secondary">🎒 ¿Listo para tu siguiente aventura?</p>
                <a href="/tours" className="btn btn-primary mt-2">
                  🔎 Explora todas las rutas
                </a>
              </div>

          }




        </div>
        <br></br>

        {/* Beneficios Tiger Club */}
        <div className="mb-4">
          <h3 className="text-muted camping-letters">Beneficios del Tiger Club</h3>
          {
            (answer === 'Aplica Beneficio') ?

              <div className="card overflow-hidden">
                <div className="row g-0">
                  <div className="col-md-4 p-3">
                    <img src={`/assets/images/bennefits/activos.jpeg`} className="rounded img-fluid " alt="imagen" width="100%" height="auto" />
                  </div>
                  <div className="col-md-8 p-3">
                    <div className="alert alert-success" role="alert" >
                      <p>Felicidades disfruta de tus beneficios hasta: </p>
                      <p>{bennefitsDate.end}</p>
                    </div>
                  </div>
                </div>
              </div>


              : (answer === 'Aplica Fecha Futura') ?

                <div className="card overflow-hidden">
                  <div className="row g-0">
                    <div className="col-md-4 p-3">
                      <img src={`/assets/images/bennefits/proximamente.jpeg`} className="rounded img-fluid " alt="imagen" width="100%" height="auto" />
                    </div>
                    <div className="col-md-8 p-3">
                      <div className="alert alert-warning" role="alert" >
                        <p>Pronto podras canjear tus beneficios.<br></br>
                          <br></br>Tus beneficios estarán disponibles del: <b>{bennefitsDate.init}</b> al <b>{bennefitsDate.end}</b>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                :
                (answer === 'No aplica') ?


                  <div className="card overflow-hidden">
                    <div className="row g-0">
                      <div className="col-md-4 p-3">

                        <img src={`/assets/images/bennefits/noaplica.jpeg`} className="rounded img-fluid " alt="imagen" width="100%" height="auto" />

                      </div>
                      <div className="col-md-8 p-3">
                        <div className="alert alert-danger" role="alert" >
                          <p>Lo sentimos! No accedes a los beneficios</p>
                          <p>Únete a un tour y desbloquea recompensas únicas.</p>
                        </div>
                      </div>
                    </div>
                  </div>



                  :
                  (answer === 'No aplica fecha pasada') ?
                    <div className="alert alert-danger" role="alert" >
                      <p>Lo sentimos! No accedes a los beneficios.
                        {/* <br></br>Tus beneficios estuvieron disponibles del: {bennefitsDate.init} al {bennefitsDate.end}</p> */}
                      </p>
                    </div>
                    :
                    <p></p>

          }



          {/* <div className="card overflow-hidden">
            <div className="row g-0">
              <div className="col-md-4">
                <div
                  className="h-100 w-100 bg-secondary"
                  style={{ minHeight: '150px' }}
                ></div>
              </div>
              <div className="col-md-8 p-3">
                <p className="mb-1">10% de descuento</p>
                <p className="mb-0">1 salida gratuita este mes</p>
              </div>
            </div>
          </div> */}
        </div>


        {/* Explora todos los tours */}
        <div className="text-center">
          <button className="btn btn-primary">Explora todos los tours</button>
        </div>
      </div>
    </>
  )
}
